export const PHASES = {
  CREATE_COLONY: 0,
  INFORMATION: 1,
  MINE: 2,
  BUILD: 3,
}

export const SCREENS = {
  LOADER_SCREEN: ['loader_screen'],
  CREATE_COLONY: ['phase0_screen'],
  INFORMATION: ['phase1_screen'],
  MINE: ['map_screen'],
  BUILD: ['map_screen'],
}

export const SESSION_START_TIMER_ID = 'SESSION_START_TIMER_ID'
